import { Avatar, Box ,Grid2, Stack, Typography } from '@mui/material';
import MainCard from 'components/MainCard';
import { Book } from 'iconsax-react';

interface MessageCardProps {
  title: string;
  message: string;
  src: string | null;
  name: string;
  courseName: string;
}

const MessageCard = ({ title, message, src, name, courseName }: MessageCardProps) => {
  const parser = new DOMParser();
  return (
    <MainCard>
      <Grid2 container spacing={1.5}>
        <Grid2 size={12}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {src ? (
              <Avatar variant="rounded" alt="course" src={src} />
            ) : (
              <Avatar alt="course" variant="rounded">
                <Book />
              </Avatar>
            )}
            <Typography variant="body2" color="secondary" sx={{
              fontWeight: '700', overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: '1',
              WebkitBoxOrient: 'vertical',
            }}>
              {courseName}
            </Typography>
          </Stack>
          <Box sx={{ textAlign: 'end' }}>
            <Typography
              sx={{ fontSize: '10px' }}
              variant="caption"
              color="secondary"
            >
              {'~ ' + name}
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ paddingTop: '0px !important' }}>
          <Typography variant="subtitle1">{title}</Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography>{parser.parseFromString(message, 'text/html').documentElement.textContent}</Typography>
        </Grid2>
      </Grid2>
    </MainCard>
  );
};

export default MessageCard;
